import React from 'react';
import styled, { css } from 'styled-components';

import { StockMobileSidePanelProps } from '@/components/StockMobileSidePanel/StockMobileSidePanel.types';
import Arrow from '@/assets/svg/chevron-right-24dp.svg';
import Lock from '@/assets/svg/lock.svg';
import FilterIcon from '@/assets/svg/icon-filter.svg';
import { colors } from '@/constants/theme';

import SidePanel from './components/SidePanel';

function StockMobileSidePanel({
  title,
  children,
  disabled,
  isOutsideButton,
  isInnerSidePanel,
  zIndex,
  onOpen,
  onDelete,
  onClose,
  isOpened,
}: StockMobileSidePanelProps) {
  function handleOpenSidebar() {
    onOpen?.();
  }

  function handleCloseSidebar() {
    onClose?.();
  }

  return (
    <Component>
      <Button
        onClick={handleOpenSidebar}
        disabled={disabled}
        isOutsideButton={isOutsideButton}
      >
        <ButtonTitle isOutsideButton={isOutsideButton}>{title}</ButtonTitle>
        <ButtonSvg>
          {isOutsideButton ? (
            <FilterIcon className="filter" />
          ) : disabled ? (
            <Lock />
          ) : (
            <Arrow className="arrow" />
          )}
        </ButtonSvg>
      </Button>
      <SidePanel
        title={title}
        isOpen={isOpened ?? false}
        onClose={handleCloseSidebar}
        children={children}
        isOutsideButton={isOutsideButton}
        isInnerSidePanel={isInnerSidePanel}
        zIndex={zIndex}
        onDelete={onDelete}
      />
    </Component>
  );
}

export default StockMobileSidePanel;

const Component = styled.div`
  width: 100%;
`;

const Button = styled.div<{ disabled?: boolean; isOutsideButton?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 55px;
  padding: 18px 15px;
  border-bottom: 1px solid ${(props) => props.theme.gray};

  ${({ disabled, isOutsideButton }) =>
    disabled &&
    !isOutsideButton &&
    css`
      pointer-events: none;
    `}

  ${({ isOutsideButton }) =>
    isOutsideButton &&
    css`
      height: 40px;
      padding: 10px 20px 9px;
      border: 1px solid ${colors.main};
      border-radius: 55px;
    `}
`;

const ButtonTitle = styled.div<{ isOutsideButton?: boolean }>`
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.blue100};

  ${({ isOutsideButton }) =>
    isOutsideButton &&
    css`
      font-weight: 700;
      color: ${(props) => props.theme.black200};
    `}
`;

const ButtonSvg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .filter {
    path {
      fill: ${(props) => props.theme.main};
    }
  }

  .arrow {
    fill: ${(props) => props.theme.gray1500};
    margin-right: -5px;
  }
`;
